import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 分页组件（Swiper）
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
// 图片数据处理
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
// 碎片组件
import Chip from 'Chip';
// 组件
import NavLong from '../NavLong';
import Content from './Content';
const Meteorological = ({ content }) => {

    const { meteorological, meteorologicalTitle } = content;

return (
        <div className={styles.wrap}>
            <Chip 
                key="meteorologicalTitle"
                id="260162"
                name="meteorologicalTitle"
                type="struct"
                title="气象现实项目标题"
                groupName="气象现实项目标题"
                content={meteorologicalTitle}
            >
                <NavLong />
            </Chip>
            <Chip 
                key="meteorological"
                id="285745"
                name="meteorological"
                type="recommend"
                title="气象现实项目"
                groupName="气象现实项目"
                content={meteorological}
            >
                <Content />
            </Chip>
        
        </div>
    );
};

Meteorological.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Meteorological);
